module.exports = __webpack_public_path__ + "img/scalable-secure.205aacc9.png";